import axios from "axios";
axios.defaults.headers.common['Authorization'] = localStorage.getItem('auth_token');

const serviceUsers = {};
const { REACT_APP_API_URL, REACT_APP_API_URL_REPORTES } = process.env;
const REPORTES_BASE = (REACT_APP_API_URL_REPORTES || 'http://localhost:4005').replace(/\/$/, '');


//? Esta solicitud trae todos los usuarios de dominio -> Endpoint de Servicio de Autenticacion
//! Verificar para mover o no
serviceUsers.consultUsersDomainAxios = async () => {
  return await axios({
    method: "get",
    url: `${REACT_APP_API_URL}/admin/api/user/list`,
    // url: 'http://localhost:4003/api/user/list',
    responseType: "json",
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: err.message });
};

//? lista todo los usuarios de Reportes
serviceUsers.listUsersReportesAxios = async () => {
  return await axios({
    method: "get",
    url: `${REPORTES_BASE}/api/usersreportes/listAll`,
    // url: 'http://localhost:4003/api/usersReportes/listAll',
    responseType: "json",
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: err.message });
};

//? Lista solo un usuario
serviceUsers.listOneUsersReportesAxios = async (data) => {
  const ci = data
  return await axios({
    method: "get",
    url: `${REPORTES_BASE}/api/usersreportes/list/`,
    // url: 'http://localhost:4003/api/usersReportes/list',
    params: {
      ci: ci,
    },
  })
    .then((response) => response.data.msg)
    .catch((err) => err.response?.data || { error: err.message });
};

//? Crea nuevo usuario
serviceUsers.createUserReportesAxios = async (data) => {
  const { correo, username, email, mail, nombres, apellidos, ci, rol } = data;
  const correoFinal = correo || username || email || mail || (ci ? `${ci}@local` : "");
  return await axios({
    method: "post",
    url: `${REPORTES_BASE}/api/usersreportes/create`,
    // url: 'http://localhost:4003/api/usersReportes/create',
    data: {
      correo: correoFinal,
      nombres: nombres,
      apellidos: apellidos,
      ci: ci,
      rol: rol,
      fechaAlta: Date.now()
    },
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: err.message });
};

//? Edita los usuarios
serviceUsers.editUserReportesAxios = async (data) => {
  const { _id, correo, nombres, apellidos, ci, rol } = data;
  return await axios({
    method: "post",
    url: `${REPORTES_BASE}/api/usersreportes/edit/${_id}`,
    data: {
      correo: correo,
      nombres: nombres,
      apellidos: apellidos,
      ci: ci,
      rol: rol,
    },
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: err.message });
};

//? Eliminar  usuarios
serviceUsers.deleteUserReportesAxios = async (data) => {
  const ci = typeof data === "object" && data !== null ? data.ci : data;
  return await axios({
    method: "delete",
    url: `${REPORTES_BASE}/api/usersreportes/delete/${ci}`,
    // url: `http://localhost:4003/api/usersReportes/delete/${data}`,
  })
    .then((response) => response.data)
    .catch((err) => err.response?.data || { error: err.message });
};

//? servicio de recuperar datos de un usuario por id -> Endpoint del servicio de vacaciones
//!Verficar para mover o no
serviceUsers.listOneUserDataAxios = async (data)=>{ 
  const idUser= data;
    return await   axios({
        method: "get",
        url: `${REACT_APP_API_URL}/admin/api/user/list/${idUser}`,
        responseType: "json",
      })
      .then((response) => response.data)
      .catch((err) => err.response?.data || { error: err.message });

}

export default serviceUsers;
